import { render } from "./Calendar.vue?vue&type=template&id=61066e31&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=61066e31&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61066e31"]])

export default __exports__